import { types } from "../../types/types"
import { startAlerta } from "../ui/alertas"
import { finishSpinner, startSpinner } from "../ui/spinner"
import ContratacionesService from '../../services/ContratacionesService';
import { handleErrorApi } from "../../helpers/randoms";

export const setearContactoEditDelete = (payload) => {
    return {
        type: types.contratacionesSetearContactoEditDelete,
        payload
    }
}

export const setOpenDeleteModal = (payload) => {
    return {
        type: types.contratacionesOpenDeleteConfirmModalEfector,
        payload,
    }
}

export const setOpenCreateEditModal = (payload) => {
    return {
        type: types.contratacionesOpenCreateEditModalEfector,
        payload,
    }
}

export const getContactosEfector = (id) => async (dispatch) => {
    try {
        dispatch({ type: types.contratacionesTraerContactoStart })
        const response = await ContratacionesService.traerContactos(id)
        const body = await response.json()
        if (response.ok) {
            dispatch({
                type: types.contratacionesTraerContactoSuccess,
                payload: body
            })
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.contratacionesTraerContactoError })
        handleErrorApi(dispatch, error, "Error al traer los tipos de efectores", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const contratacionesContactoDelete = (idEfectorContacto) => {
    return async (dispatch, getState) => {
        try {
            const { dataContrato } = getState().contrataciones
            let response = null;
            response = await ContratacionesService.borrarContacto(idEfectorContacto)
            const body = await response.json()
            if (response.ok) {
                dispatch(setearContactoEditDelete(null));
                dispatch(getContactosEfector(dataContrato.idEfectorFacturacion));
                dispatch(startAlerta("Contacto Borrado Exitosamente", 'success', 'Comando Exitoso'));
            } else {
                dispatch(startAlerta(response.errores, "error", "Error"));
                throw body;
            }
        } catch (error) {
            handleErrorApi(dispatch, error, "Error al eliminar un contacto", "Ha ocurrido un error. Intente nuevamente")
        }
    }
}

export const contratacionesContactoStore = (dataContacto) => {
    return async (dispatch, getState) => {
        try {
            dispatch(startSpinner())
            const { dataContrato } = getState().contrataciones;
            dataContacto.idEfectorFacturacion = dataContrato.idEfectorFacturacion;
            let response = null;
            if (dataContacto.idEfectorContacto === null) {
                response = await ContratacionesService.guardarContacto(dataContacto);
            } else {
                response = await ContratacionesService.actualizarContacto(dataContacto.idEfectorContacto, dataContacto);
            }
            const body = await response.json();
            if (response.ok) {
                dispatch(setearContactoEditDelete(null));
                dispatch(setOpenCreateEditModal(false));
                dispatch(getContactosEfector(dataContrato.idEfectorFacturacion))
                dispatch(finishSpinner());
                if (dataContacto.idEfectorContacto === null) {
                    dispatch(startAlerta("Contacto Guardado Exitosamente", 'success', 'Comando Exitoso'));
                } else {
                    dispatch(startAlerta("Contacto Editado Exitosamente", 'success', 'Comando Exitoso'));
                }
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(dispatch, error, "Error al guardar un contacto", "Ha ocurrido un error. Intente nuevamente")
        }
    }
}

export const getObservacionesContactosEfector = () => async (dispatch, getState) => {
    try {
        dispatch({ type: types.contratacionesTraerObservacionesContactoStart })
        const response = await ContratacionesService.traerObservacionesContactos(getState().contrataciones.dataContrato.idEfectorFacturacion)
        const body = await response.json()
        if (response.ok) {
            dispatch({
                type: types.contratacionesTraerObservacionesContactoSuccess,
                payload: body
            })
        } else {
            throw body
        }
    } catch (error) {
        dispatch({ type: types.contratacionesTraerObservacionesContactoError })
        handleErrorApi(dispatch, error, "Error al traer las observaciones de los contactos", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const contratacionesObservacionesContactoDelete = (idEfectorContactoObservacion) => {
    return async (dispatch) => {
        dispatch(startSpinner())
        try {
            let response = await ContratacionesService.borrarObservacionesContacto(idEfectorContactoObservacion)
            const body = await response.json()
            if (response.ok) {
                dispatch(getObservacionesContactosEfector());
                dispatch(finishSpinner())
                dispatch(startAlerta("Observacion borrada exitosamente", 'success', 'Comando Exitoso'));
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner())
            handleErrorApi(dispatch, error, "Error al eliminar una observacion", "Ha ocurrido un error. Intente nuevamente")
        }
    }
}

export const contratacionesObservacionesContactoStore = (dataObservacion, handleAfter) => {
    return async (dispatch, getState) => {
        try {
            dispatch(startSpinner())
            const { dataContrato } = getState().contrataciones;
            dataObservacion.idEfectorFacturacion = dataContrato.idEfectorFacturacion;
            const response = await ContratacionesService.guardarObservacionesContacto(dataObservacion);
            const body = await response.json();
            if (response.ok) {
                handleAfter()
                dispatch(getObservacionesContactosEfector());
                dispatch(finishSpinner());
                dispatch(startAlerta("Observacion Guardada Exitosamente", 'success', 'Comando Exitoso'));
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(dispatch, error, "Error al guardar una observacion", "Ha ocurrido un error. Intente nuevamente")
        }
    }
}

export const getTiposContactoEfectores = () => async (dispatch) => {
    try {
        dispatch({ type: types.contratacionesTraerTipoContactoStart })
        const response = await ContratacionesService.traerTipoContactoEfector()
        const body = await response.json()
        if (response.ok) {
            dispatch({
                type: types.contratacionesTraerTipoContactoSuccess,
                payload: body
            })
        } else {
            throw body
        }
    } catch (error) {
        console.log("Error al traer los tipos de efectores")
        dispatch({ type: types.contratacionesTraerTipoContactoError })
        handleErrorApi(dispatch, error, "Error al obtener tipos de contacto", "Ha ocurrido un error. Intente nuevamente")
    }
};
